import React from 'react';
import cx from 'classnames';
import './AccountWrapper.scss';

export default ({ children, isBedRockChangePayment, showInvoicesFirst }) => {
	return (
		<div
			className={cx('account account-page-bedrock', {
				['change-payment-details-bedrock-wrapper']: isBedRockChangePayment,
				['account-page-bedrock--show-invoices-list-first']: showInvoicesFirst,
			})}
		>
			{children}
		</div>
	);
};
